// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "photos-" + chunkId + ".js?v=" + {"vendors-node_modules_leaflet-defaulticon-compatibility_src_Icon_Default_compatibility_js-node-a43fe3":"d23ca1df32708a71cebc","src_views_PhotosTab_vue":"79376f50b88333e6facf"}[chunkId] + "";
};